import nestAxios from './_nestAxios'

export const obtenerPlacasxIdSocio = idSocio => nestAxios.get(`/socios/${idSocio}/placas`)

export const obtenerContactoxIdSocioxIdContacto = (idSocio, idContacto) => nestAxios.get(`/socios/${idSocio}/contactos/${idContacto}`)

export const obtenerContactosxIdSocio = idSocio => nestAxios.get(`/socios/${idSocio}/contactos`)

export const actualizarSocio = (_id, data) => nestAxios.put(`/socios/${_id}`, data)

export const importarExcelSocios = data => nestAxios.post('/socios/importar', data)

export const descargarPlantillaImportarSocios = () =>
  nestAxios.get('/socios/descargar/plantilla', {
    responseType: 'blob'
  })

export const actualizarSobrenombreSocioxId = (_id, sobrenombre) => nestAxios.put(`/socios/${_id}/sobrenombre`, { sobrenombre })

export const actualizarContactoxIdSocioxIdContacto = (idSocio, idContacto, contactoData) =>
  nestAxios.put(`/socios/${idSocio}/contactos/${idContacto}`, contactoData)

export const nuevaPlacaxIdSocio = (idSocio, placaData) => nestAxios.post(`/socios/${idSocio}/placas`, placaData)

export const nuevoContactoxIdSocio = (idSocio, contactoData) => nestAxios.post(`/socios/${idSocio}/contactos`, contactoData)

export const eliminarSocio = _id => nestAxios.delete(`/socios/${_id}`)

export const eliminarPlacaxIdSocioxIdPlaca = (id, idPlaca) => nestAxios.delete(`/socios/${id}/placas/${idPlaca}`)

export const eliminarContactoxIdSocioxIdContacto = (id, idContacto) => nestAxios.delete(`/socios/${id}/contactos/${idContacto}`)

export const obtenerSociosAsSelect2 = busqueda => nestAxios.get(`/socios`, { params: { tipoConsulta: 'select2', busqueda: busqueda } })

export const getNuevoCodigo = () => nestAxios.get('/socios/nuevo-codigo')

export const getSocio = _id => nestAxios.get(`/socios/${_id}`)

export const getSocioViaSunat = ruc => nestAxios.get(`/socios/consulta-ruc/${ruc}`)

export const obtenerInfoSocioxIdAsSlimSobrenombre = _id => nestAxios.get(`/socios/${_id}`, { params: { tipoConsulta: 'slim-sobrenombre' } })

export const obtenerClientesxBusquedaAsSelect2 = ({ busqueda, tipoBusqueda }) =>
  nestAxios.get('/socios', {
    params: {
      tipoConsulta: 'select2-cliente',
      busqueda,
      tipoBusqueda
    }
  })

export const obtenerClientesAkdemicxBusquedaAsSelect2 = ({ busqueda, tipoBusqueda }) =>
  nestAxios.get('/socios', {
    params: {
      tipoConsulta: 'select2-cliente-akdemic',
      busqueda,
      tipoBusqueda
    }
  })

export const obtenerProveedoresxBusquedaAsSelect2 = ({ busqueda }) =>
  nestAxios.get('/socios', {
    params: {
      tipoConsulta: 'select2-proveedor',
      busqueda
    }
  })

export const obtenerSociosOtrosxBusquedaAsSelect2 = ({ busqueda }) =>
  nestAxios.get('/socios', {
    params: {
      tipoConsulta: 'select2-otros',
      busqueda
    }
  })

export const obtenerIdClienteVarios = () => nestAxios.get('/socios/cliente-varios')

export const nuevoSocio = data => nestAxios.post('/socios', data)

export const obtenerxIdAsEdicionFromVentas = id =>
  nestAxios.get(`/socios/${id}`, {
    params: {
      tipoConsulta: 'edicion-ventas'
    }
  })

export const obtenerxIdAsInfoSlim = _id =>
  nestAxios.get(`/socios/${_id}`, {
    params: {
      tipoConsulta: 'slim-info'
    }
  })

export const obtenerPlacasxIdSocioAsSelect = idSocio =>
  nestAxios.get(`/socios/${idSocio}/placas`, {
    params: { tipoConsulta: 'select' }
  })

export const obtenerDireccionesxIdSocioAsSelect = idSocio =>
  nestAxios.get(`/socios/${idSocio}/direcciones`, {
    params: {
      tipoConsulta: 'select'
    }
  })

export const obtenerContactosxIdSocioAsSelect = idSocio =>
  nestAxios.get(`/socios/${idSocio}/contactos`, {
    params: {
      tipoConsulta: 'select'
    }
  })

export const nuevaDireccion = (_idSocio, direccionData) => nestAxios.post(`/socios/${_idSocio}/direcciones`, direccionData)

export const nuevoSocioViaVentas = data =>
  nestAxios.post('/socios', data, {
    params: {
      tipoConsulta: 'ventas'
    }
  })

export const nuevoSocioViaCompras = data =>
  nestAxios.post('/socios', data, {
    params: {
      tipoConsulta: 'compras'
    }
  })

export const descargarExcelSocios = () =>
  nestAxios.get('/socios/descargar/excel', {
    responseType: 'blob'
  })

// Documentos
export const obtenerDocumentosxIdSocio = idSocio => nestAxios.get(`/socios/${idSocio}/documentos`)

export const agregarDocumentoxIdSocio = (idSocio, { tipo, file, comentario }) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('tipo', tipo)
  if (comentario) formData.append('comentario', comentario)
  return nestAxios.post(`/socios/${idSocio}/documentos`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const descargarDocumentoSocio = idDocumento =>
  nestAxios.get(`/socios/documentos/${idDocumento}/descargar`, { responseType: 'blob' })

export const eliminarDocumentoSocio = idDocumento => nestAxios.delete(`/socios/documentos/${idDocumento}`)